<template>
    <div
      class="main-error bg-white p-40"
      :style="{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover', 
        backgroundPosition: 'center'
      }"
    >
        <div class="box p-4 mt-10 flex flex-col items-center justify-center bg-white">
            <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5333 38.75L25.8333 29.45L35.1333 38.75L38.75 35.1333L29.45 25.8333L38.75 16.5333L35.1333 12.9167L25.8333 22.2167L16.5333 12.9167L12.9167 16.5333L22.2167 25.8333L12.9167 35.1333L16.5333 38.75ZM25.8333 51.6667C22.2597 51.6667 18.9014 50.9885 15.7583 49.6323C12.6153 48.276 9.88125 46.4354 7.55625 44.1104C5.23125 41.7854 3.39062 39.0514 2.03437 35.9083C0.678125 32.7653 0 29.4069 0 25.8333C0 22.2597 0.678125 18.9014 2.03437 15.7583C3.39062 12.6153 5.23125 9.88125 7.55625 7.55625C9.88125 5.23125 12.6153 3.39062 15.7583 2.03437C18.9014 0.678125 22.2597 0 25.8333 0C29.4069 0 32.7653 0.678125 35.9083 2.03437C39.0514 3.39062 41.7854 5.23125 44.1104 7.55625C46.4354 9.88125 48.276 12.6153 49.6323 15.7583C50.9885 18.9014 51.6667 22.2597 51.6667 25.8333C51.6667 29.4069 50.9885 32.7653 49.6323 35.9083C48.276 39.0514 46.4354 41.7854 44.1104 44.1104C41.7854 46.4354 39.0514 48.276 35.9083 49.6323C32.7653 50.9885 29.4069 51.6667 25.8333 51.6667Z" fill="#D92D20"/>
            </svg>
            <h2 class="mt-2">{{ errorTitle }}</h2>
            <p>{{ errorMessage }}</p>
            <button class="mt-4" @click="$router.push('/login')">Volver a Tu Recibo</button>
        </div>
        <div class="box-logo flex justify-center border-t border-gray-200">
            <img :src="logo" alt="logo">
        </div>
    </div>
</template>

<script>


export default {
    data() {
        return {
            logo: `${window.sichern.cdnURL}/media/custom/login/sichern_logo.jpg`,
            backgroundImage: `${window.sichern.cdnURL}/media/images/login-background.jpg`,
            subdomain: '',
        };
    },
    computed: {
        errorTitle() {
            const titles = {
                account_linking_failed: 'Cuenta sin vincular',
                auth_error: 'Error de autenticación',
                internal_server_error: 'Error interno del servidor',
                unauthorized_access: 'Acceso no autorizado',
                unexpected_server_response: 'Respuesta inesperada del servidor',
                unexpected_response_code: 'Código de respuesta inesperado',
            };
            const code = this.$route.query.error_code;
            return titles[code] || 'Error inesperado';
        },
        errorMessage() {
            const messages = {
                account_linking_failed: 'Tu cuenta no está vinculada con\nSichern Connect.',
                auth_error: 'Ocurrió un error durante el proceso de autenticación.\nPor favor, intentá iniciar sesión nuevamente.',
                internal_server_error: 'Ocurrió un error interno en el servidor.\nPor favor, intentá nuevamente.',
                unauthorized_access: 'No tenés autorización para acceder con esta cuenta.',
                unexpected_server_response: 'El servidor devolvió una respuesta inesperada.\nPor favor, intentá nuevamente.',
                unexpected_response_code: 'El servidor devolvió un código de respuesta inesperado.\nPor favor, intentá nuevamente.',
            };
            const code = this.$route.query.error_code;
            return messages[code] || 'Ocurrió un error inesperado.';
        }
    },
    created() {
        const url = new URL(window.location.href);
        const parts = url.hostname.split('.');
        const subdomain = parts.length > 2 ? parts[0] : null;
        if (subdomain) {
            const candidateUrl = `${window.sichern.cdnURL}/media/custom/login/${subdomain}_logo.jpg`;
            const img = new Image();
            img.onload = () => { this.logo = candidateUrl; };
            img.src = candidateUrl;
        }
    },
}
</script>

<style scoped>
.main-error {
  min-height: 100vh;
  color: #101828;
  padding: 72px;
}
.box {
    max-width: 550px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    aspect-ratio: 1 / 1;
    min-height: 240px;
}
.box-logo {
    max-width: 550px;
    height: 60px !important;
    padding: 10px;
    background: #fdfdfd;
    margin: 0 auto;
}
img {
    width: auto;
    max-height: 100%;
    object-fit: contain;
}
h2 {
    font-size: 20px;
    font-weight: 600;
}
p {
    font-size: 16px;
    white-space: pre-line;
}
button {
    width: 151px;
    height: 48px;
    background: #344054;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    cursor: pointer;

}
</style>